// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ReadinessView-module__root___F8FRW {
  display: block;
}

.ReadinessView-module__toolbar___Ua108 {
  display: flex;
  align-items: center;
  gap: 12px;
  justify-content: space-between;
  padding: 10px 12px;
  margin-bottom: 16px;
  background: #ffffff;
  border: 1px solid #e4e4e7;
  border-radius: 8px;
}

.ReadinessView-module__departmentTabs___WLDwd {
  display: flex;
  align-items: center;
  gap: 4px;
  flex-wrap: wrap;
}

.ReadinessView-module__departmentTab___r0Qzx {
  border-top: 1px solid transparent;
  border-right: 1px solid transparent;
  border-bottom: 1px solid transparent;
  border-left: 1px solid transparent;
  border-radius: 4px;
  background: #fafafa;
  color: #71717a;
  font-size: 14px;
  font-weight: 500;
  padding: 7px 12px;
  transition: background 0.15s ease, border-color 0.15s ease, color 0.15s ease, box-shadow 0.15s ease;
}

.ReadinessView-module__departmentTab___r0Qzx:hover {
  color: #18181b;
  background: #f4f4f5;
}

.ReadinessView-module__departmentTabActive___smxrD {
  color: #18181b;
  background: #ffffff;
  border-top-color: #e4e4e7;
  border-right-color: #e4e4e7;
  border-left-color: #e4e4e7;
  box-shadow: 0 1px 2px rgba(24, 24, 27, 0.04);
}

.ReadinessView-module__departmentTab___r0Qzx[data-tone=green] {
  border-bottom: 2px solid #86efac;
}

.ReadinessView-module__departmentTab___r0Qzx[data-tone=yellow] {
  border-bottom: 2px solid #facc15;
}

.ReadinessView-module__departmentTab___r0Qzx[data-tone=red] {
  border-bottom: 2px solid #fca5a5;
}

.ReadinessView-module__toolbarMeta___uCjKF {
  font-size: 13px;
  color: #a1a1aa;
  white-space: nowrap;
}

.ReadinessView-module__statsRow___Fzb8c {
  display: flex;
  gap: 12px;
  margin-bottom: 16px;
}

.ReadinessView-module__statCard___JwmSD {
  flex: 1;
  background: #ffffff;
  border: 1px solid #e4e4e7;
  border-radius: 8px;
  padding: 12px 14px;
}

.ReadinessView-module__statLabel___xH9uu {
  font-size: 11px;
  color: #71717a;
  font-weight: 500;
  margin-bottom: 2px;
}

.ReadinessView-module__statValueRow___SWgtz {
  display: flex;
  align-items: baseline;
  gap: 6px;
}

.ReadinessView-module__statValue___gpwq9 {
  font-size: 22px;
  font-weight: 700;
  font-family: "IBM Plex Mono", monospace;
  color: #18181b;
}

.ReadinessView-module__statValuegreen___yYzMe {
  color: #22c55e;
}

.ReadinessView-module__statValueyellow___pQM81 {
  color: #eab308;
}

.ReadinessView-module__statValuered___NjOd9 {
  color: #ef4444;
}

.ReadinessView-module__statSub___Cba_Q {
  font-size: 11px;
  color: #a1a1aa;
}

.ReadinessView-module__layout___PkfL6 {
  display: grid;
  grid-template-columns: 1fr;
  gap: 16px;
  align-items: start;
}

.ReadinessView-module__layoutWithDetail___rDJzR {
  grid-template-columns: minmax(0, 1fr) 430px;
}

.ReadinessView-module__listColumn___NmmuZ {
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding-bottom: 80px;
}

.ReadinessView-module__loaderWrap___AAQxm {
  display: flex;
  justify-content: center;
  padding: 20px 0;
}

.ReadinessView-module__emptyFilterState___ZJ5uJ {
  padding: 24px;
  background: #ffffff;
  border: 1px dashed #e4e4e7;
  border-radius: 8px;
  color: #71717a;
  font-size: 14px;
  text-align: center;
}

.ReadinessView-module__dateGroup___UpiWG {
  display: block;
}

.ReadinessView-module__dateHeader___Tc5kD {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 8px;
}

.ReadinessView-module__dateLeft___dgpum {
  width: 40px;
  text-align: center;
}

.ReadinessView-module__dateDayName___MkpZU {
  font-size: 10px;
  font-weight: 600;
  text-transform: uppercase;
}

.ReadinessView-module__dateDayNumber___nWd9s {
  font-size: 18px;
  font-weight: 700;
  font-family: "IBM Plex Mono", monospace;
}

.ReadinessView-module__dateToday___lttxI {
  color: #18181b;
}

.ReadinessView-module__dateNormal___og5uT {
  color: #52525b;
}

.ReadinessView-module__dateMuted___ItKX3 {
  color: #a1a1aa;
}

.ReadinessView-module__dateDivider___KfCJL {
  flex: 1;
  height: 1px;
  background: #e4e4e7;
}

.ReadinessView-module__dateMeta___o2LwC {
  font-size: 11px;
  color: #a1a1aa;
}

.ReadinessView-module__cardsGrid___Ew7PE {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));
  gap: 8px;
  padding-left: 48px;
}

.ReadinessView-module__detailPanel___Svmpm {
  align-self: start;
  min-width: 0;
  position: sticky;
  top: 16px;
  max-height: calc(100vh - var(--tabs-navigation) - var(--secondary-navigation) - var(--patient-details-footer) - 54px);
  overflow-y: auto;
  scrollbar-width: none;
  padding-bottom: 80px;
}

.ReadinessView-module__detailPanel___Svmpm::-webkit-scrollbar {
  width: 0;
  height: 0;
}

@media (max-width: 960px) {
  .ReadinessView-module__toolbar___Ua108 {
    align-items: flex-start;
    flex-direction: column;
  }
  .ReadinessView-module__toolbarMeta___uCjKF {
    white-space: normal;
  }
  .ReadinessView-module__statsRow___Fzb8c {
    flex-direction: column;
  }
  .ReadinessView-module__layoutWithDetail___rDJzR {
    grid-template-columns: 1fr;
  }
  .ReadinessView-module__detailPanel___Svmpm {
    position: static;
    max-height: none;
    overflow-y: visible;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/CareOrchestration/components/ReadinessView/ReadinessView.module.scss"],"names":[],"mappings":"AAAA;EACE,cAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,8BAAA;EACA,kBAAA;EACA,mBAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;AACF;;AAEA;EACE,iCAAA;EACA,mCAAA;EACA,oCAAA;EACA,kCAAA;EACA,kBAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,mGACE;AAAJ;;AAMA;EACE,cAAA;EACA,mBAAA;AAHF;;AAMA;EACE,cAAA;EACA,mBAAA;EACA,yBAAA;EACA,2BAAA;EACA,0BAAA;EACA,4CAAA;AAHF;;AAMA;EACE,gCAAA;AAHF;;AAMA;EACE,gCAAA;AAHF;;AAMA;EACE,gCAAA;AAHF;;AAMA;EACE,eAAA;EACA,cAAA;EACA,mBAAA;AAHF;;AAMA;EACE,aAAA;EACA,SAAA;EACA,mBAAA;AAHF;;AAMA;EACE,OAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,kBAAA;AAHF;;AAMA;EACE,eAAA;EACA,cAAA;EACA,gBAAA;EACA,kBAAA;AAHF;;AAMA;EACE,aAAA;EACA,qBAAA;EACA,QAAA;AAHF;;AAMA;EACE,eAAA;EACA,gBAAA;EACA,uCAAA;EACA,cAAA;AAHF;;AAMA;EACE,cAAA;AAHF;;AAMA;EACE,cAAA;AAHF;;AAMA;EACE,cAAA;AAHF;;AAMA;EACE,eAAA;EACA,cAAA;AAHF;;AAMA;EACE,aAAA;EACA,0BAAA;EACA,SAAA;EACA,kBAAA;AAHF;;AAMA;EACE,2CAAA;AAHF;;AAMA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,oBAAA;AAHF;;AAMA;EACE,aAAA;EACA,uBAAA;EACA,eAAA;AAHF;;AAMA;EACE,aAAA;EACA,mBAAA;EACA,0BAAA;EACA,kBAAA;EACA,cAAA;EACA,eAAA;EACA,kBAAA;AAHF;;AAMA;EACE,cAAA;AAHF;;AAMA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,kBAAA;AAHF;;AAMA;EACE,WAAA;EACA,kBAAA;AAHF;;AAMA;EACE,eAAA;EACA,gBAAA;EACA,yBAAA;AAHF;;AAMA;EACE,eAAA;EACA,gBAAA;EACA,uCAAA;AAHF;;AAMA;EACE,cAAA;AAHF;;AAMA;EACE,cAAA;AAHF;;AAMA;EACE,cAAA;AAHF;;AAMA;EACE,OAAA;EACA,WAAA;EACA,mBAAA;AAHF;;AAMA;EACE,eAAA;EACA,cAAA;AAHF;;AAMA;EACE,aAAA;EACA,4DAAA;EACA,QAAA;EACA,kBAAA;AAHF;;AAMA;EACE,iBAAA;EACA,YAAA;EACA,gBAAA;EACA,SAAA;EACA,qHAAA;EAIA,gBAAA;EACA,qBAAA;EACA,oBAAA;AANF;;AASA;EACE,QAAA;EACA,SAAA;AANF;;AAYA;EACE;IACE,uBAAA;IACA,sBAAA;EATF;EAYA;IACE,mBAAA;EAVF;EAaA;IACE,sBAAA;EAXF;EAcA;IACE,0BAAA;EAZF;EAeA;IACE,gBAAA;IACA,gBAAA;IACA,mBAAA;EAbF;AACF","sourcesContent":[".root {\n  display: block;\n}\n\n.toolbar {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  justify-content: space-between;\n  padding: 10px 12px;\n  margin-bottom: 16px;\n  background: #ffffff;\n  border: 1px solid #e4e4e7;\n  border-radius: 8px;\n}\n\n.departmentTabs {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  flex-wrap: wrap;\n}\n\n.departmentTab {\n  border-top: 1px solid transparent;\n  border-right: 1px solid transparent;\n  border-bottom: 1px solid transparent;\n  border-left: 1px solid transparent;\n  border-radius: 4px;\n  background: #fafafa;\n  color: #71717a;\n  font-size: 14px;\n  font-weight: 500;\n  padding: 7px 12px;\n  transition:\n    background 0.15s ease,\n    border-color 0.15s ease,\n    color 0.15s ease,\n    box-shadow 0.15s ease;\n}\n\n.departmentTab:hover {\n  color: #18181b;\n  background: #f4f4f5;\n}\n\n.departmentTabActive {\n  color: #18181b;\n  background: #ffffff;\n  border-top-color: #e4e4e7;\n  border-right-color: #e4e4e7;\n  border-left-color: #e4e4e7;\n  box-shadow: 0 1px 2px rgba(24, 24, 27, 0.04);\n}\n\n.departmentTab[data-tone='green'] {\n  border-bottom: 2px solid #86efac;\n}\n\n.departmentTab[data-tone='yellow'] {\n  border-bottom: 2px solid #facc15;\n}\n\n.departmentTab[data-tone='red'] {\n  border-bottom: 2px solid #fca5a5;\n}\n\n.toolbarMeta {\n  font-size: 13px;\n  color: #a1a1aa;\n  white-space: nowrap;\n}\n\n.statsRow {\n  display: flex;\n  gap: 12px;\n  margin-bottom: 16px;\n}\n\n.statCard {\n  flex: 1;\n  background: #ffffff;\n  border: 1px solid #e4e4e7;\n  border-radius: 8px;\n  padding: 12px 14px;\n}\n\n.statLabel {\n  font-size: 11px;\n  color: #71717a;\n  font-weight: 500;\n  margin-bottom: 2px;\n}\n\n.statValueRow {\n  display: flex;\n  align-items: baseline;\n  gap: 6px;\n}\n\n.statValue {\n  font-size: 22px;\n  font-weight: 700;\n  font-family: 'IBM Plex Mono', monospace;\n  color: #18181b;\n}\n\n.statValuegreen {\n  color: #22c55e;\n}\n\n.statValueyellow {\n  color: #eab308;\n}\n\n.statValuered {\n  color: #ef4444;\n}\n\n.statSub {\n  font-size: 11px;\n  color: #a1a1aa;\n}\n\n.layout {\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: 16px;\n  align-items: start;\n}\n\n.layoutWithDetail {\n  grid-template-columns: minmax(0, 1fr) 430px;\n}\n\n.listColumn {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  padding-bottom: 80px;\n}\n\n.loaderWrap {\n  display: flex;\n  justify-content: center;\n  padding: 20px 0;\n}\n\n.emptyFilterState {\n  padding: 24px;\n  background: #ffffff;\n  border: 1px dashed #e4e4e7;\n  border-radius: 8px;\n  color: #71717a;\n  font-size: 14px;\n  text-align: center;\n}\n\n.dateGroup {\n  display: block;\n}\n\n.dateHeader {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-bottom: 8px;\n}\n\n.dateLeft {\n  width: 40px;\n  text-align: center;\n}\n\n.dateDayName {\n  font-size: 10px;\n  font-weight: 600;\n  text-transform: uppercase;\n}\n\n.dateDayNumber {\n  font-size: 18px;\n  font-weight: 700;\n  font-family: 'IBM Plex Mono', monospace;\n}\n\n.dateToday {\n  color: #18181b;\n}\n\n.dateNormal {\n  color: #52525b;\n}\n\n.dateMuted {\n  color: #a1a1aa;\n}\n\n.dateDivider {\n  flex: 1;\n  height: 1px;\n  background: #e4e4e7;\n}\n\n.dateMeta {\n  font-size: 11px;\n  color: #a1a1aa;\n}\n\n.cardsGrid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));\n  gap: 8px;\n  padding-left: 48px;\n}\n\n.detailPanel {\n  align-self: start;\n  min-width: 0;\n  position: sticky;\n  top: 16px;\n  max-height: calc(\n    100vh - var(--tabs-navigation) - var(--secondary-navigation) - var(--patient-details-footer) -\n      54px\n  );\n  overflow-y: auto;\n  scrollbar-width: none;\n  padding-bottom: 80px;\n}\n\n.detailPanel::-webkit-scrollbar {\n  width: 0;\n  height: 0;\n}\n\n.detailPanelInner {\n}\n\n@media (max-width: 960px) {\n  .toolbar {\n    align-items: flex-start;\n    flex-direction: column;\n  }\n\n  .toolbarMeta {\n    white-space: normal;\n  }\n\n  .statsRow {\n    flex-direction: column;\n  }\n\n  .layoutWithDetail {\n    grid-template-columns: 1fr;\n  }\n\n  .detailPanel {\n    position: static;\n    max-height: none;\n    overflow-y: visible;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `ReadinessView-module__root___F8FRW`,
	"toolbar": `ReadinessView-module__toolbar___Ua108`,
	"departmentTabs": `ReadinessView-module__departmentTabs___WLDwd`,
	"departmentTab": `ReadinessView-module__departmentTab___r0Qzx`,
	"departmentTabActive": `ReadinessView-module__departmentTabActive___smxrD`,
	"toolbarMeta": `ReadinessView-module__toolbarMeta___uCjKF`,
	"statsRow": `ReadinessView-module__statsRow___Fzb8c`,
	"statCard": `ReadinessView-module__statCard___JwmSD`,
	"statLabel": `ReadinessView-module__statLabel___xH9uu`,
	"statValueRow": `ReadinessView-module__statValueRow___SWgtz`,
	"statValue": `ReadinessView-module__statValue___gpwq9`,
	"statValuegreen": `ReadinessView-module__statValuegreen___yYzMe`,
	"statValueyellow": `ReadinessView-module__statValueyellow___pQM81`,
	"statValuered": `ReadinessView-module__statValuered___NjOd9`,
	"statSub": `ReadinessView-module__statSub___Cba_Q`,
	"layout": `ReadinessView-module__layout___PkfL6`,
	"layoutWithDetail": `ReadinessView-module__layoutWithDetail___rDJzR`,
	"listColumn": `ReadinessView-module__listColumn___NmmuZ`,
	"loaderWrap": `ReadinessView-module__loaderWrap___AAQxm`,
	"emptyFilterState": `ReadinessView-module__emptyFilterState___ZJ5uJ`,
	"dateGroup": `ReadinessView-module__dateGroup___UpiWG`,
	"dateHeader": `ReadinessView-module__dateHeader___Tc5kD`,
	"dateLeft": `ReadinessView-module__dateLeft___dgpum`,
	"dateDayName": `ReadinessView-module__dateDayName___MkpZU`,
	"dateDayNumber": `ReadinessView-module__dateDayNumber___nWd9s`,
	"dateToday": `ReadinessView-module__dateToday___lttxI`,
	"dateNormal": `ReadinessView-module__dateNormal___og5uT`,
	"dateMuted": `ReadinessView-module__dateMuted___ItKX3`,
	"dateDivider": `ReadinessView-module__dateDivider___KfCJL`,
	"dateMeta": `ReadinessView-module__dateMeta___o2LwC`,
	"cardsGrid": `ReadinessView-module__cardsGrid___Ew7PE`,
	"detailPanel": `ReadinessView-module__detailPanel___Svmpm`
};
module.exports = ___CSS_LOADER_EXPORT___;
